import { api } from "../App";
import {
  SET_LIBRARY_LOADING,
  SET_LIBRARY_EDUC_DIRECTIONS,
  SET_LIBRARY_NEWS_LEVELS,
  SET_LIBRARY_EVENT_TYPES,
  SET_LIBRARY_EVENT_FORMS,
  SET_LIBRARY_PARALLELS,
  SET_LIBRARY_TEACHERS,
  SET_LIBRARY_SPECIALIST_RECORD_SECTIONS,
  SET_LIBRARY_PRIVILEGES,
  SET_LIBRARY_PENALTY_REASON_VIDS,
  SET_LIBRARY_FAMILY_ETHNICITIES,
  SET_LIBRARY_SPECIALITIES,
  SET_LIBRARY_EDU_LESSONS,
  SET_LIBRARY_MILITARY_DISTRICTS,
  SET_LIBRARY_UNIVERSITIES,
  SET_LIBRARY_DESK_NUMBERS,
  SET_LIBRARY_COUNTRIES,
  SET_LIBRARY_RF_SUBJECTS,
  SET_LIBRARY_SCHOOLS,
  SET_LIBRARY_ROOMS,
  SET_LIBRARY_EVENT_ROOMS,
  SET_LIBRARY_SOCIAL_GROUPS,
  SET_LIBRARY_PHYSICAL_TRAINING_INDICATORS,
  SET_LIBRARY_ACHIEVEMENT_TYPES,
  SET_LIBRARY_RESULT_INCLUDING,
  SET_LIBRARY_SEVERITY_LEVELS,
  SET_LIBRARY_LANGUAGES,
  SET_LIBRARY_MIL_RANKS,
  SET_LIBRARY_PORTFOLIO_YEARS,
  SET_LIBRARY_AVAILABLE_OUT_COURSES,
  SET_LIBRARY_AVAILABLE_XP_COURSES,
  SET_LIBRARY_AVAILABLE_COURSES,
  SET_LIBRARY_AVAILABLE_OUT_GROUPS,
  SET_LIBRARY_AVAILABLE_SUBGROUPS,
  SET_LIBRARY_AVAILABLE_XP_GROUPS,
  SET_LIBRARY_AVAILABLE_CLASSES,
  SET_LIBRARY_EXAM_NAMES,
  SET_LIBRARY_WEEKS,
} from "./types";

// Направления воспитательной работы (educdirection)
export const getLibraryEducDirections = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/options/educ-directions`);
    dispatch({ type: SET_LIBRARY_EDUC_DIRECTIONS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уровни мероприятий (xp_news_levels)
export const getLibraryNewsLevels = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/options/news-levels`);
    dispatch({ type: SET_LIBRARY_NEWS_LEVELS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Типы событий (xp_eventtypes)
export const getLibraryEventTypes = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/options/event-types`);
    dispatch({ type: SET_LIBRARY_EVENT_TYPES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Формы мероприятий (acttype)
export const getLibraryEventForms = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/options/event-forms`);
    dispatch({ type: SET_LIBRARY_EVENT_FORMS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};
export const getLibraryEventRooms = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/options/rooms`);
    dispatch({ type: SET_LIBRARY_EVENT_ROOMS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список параллелей для фильтра мероприятий
export const getLibraryParallels = (date_from) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const params = {};
    if (date_from) params.beg_date = date_from;
    const { data } = await api.get(`/library/groups/parallels`, { params });
    dispatch({ type: SET_LIBRARY_PARALLELS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список преподавателей для фильтра мероприятий
export const getLibraryTeachers = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/teachers`);
    dispatch({ type: SET_LIBRARY_TEACHERS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// ==================== ЛИЧНЫЕ ДЕЛА УЧАЩИХСЯ ====================

// Разделы записей специалистов (personal_info_sections)
export const getLibrarySpecialistRecordSections = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/specialist_records/sections`);
    console.log('data::: ', data);
    dispatch({ type: SET_LIBRARY_SPECIALIST_RECORD_SECTIONS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Справочник льгот (c_privilege)
export const getLibraryPrivileges = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/privileges/c_privilege`);
    dispatch({ type: SET_LIBRARY_PRIVILEGES, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уникальные виды поощрений/наказаний (xp_personal_file_penalty.reason_vid)
export const getLibraryPenaltyReasonVids = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/penalties/reason_vid`);
    dispatch({ type: SET_LIBRARY_PENALTY_REASON_VIDS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уникальные национальности членов семьи (xp_personal_file_family.ethnicity)
export const getLibraryFamilyEthnicities = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/family/ethnicities`);
    dispatch({ type: SET_LIBRARY_FAMILY_ETHNICITIES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Специальности (speciality + university_speciality)
export const getLibrarySpecialities = (universityId) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const params = universityId ? { university_id: universityId } : {};
    const { data } = await api.get(`/library/education/specialities`, { params });
    dispatch({ type: SET_LIBRARY_SPECIALITIES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список предметов (lessons)
export const getLibraryEduLessons = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/education/lessons`);
    dispatch({ type: SET_LIBRARY_EDU_LESSONS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Военный округ по субъекту РФ (military_district + xp_subjects)
export const getLibraryMilitaryDistricts = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/military_district`);
    dispatch({ type: SET_LIBRARY_MILITARY_DISTRICTS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список ВУЗов (university)
export const getLibraryUniversities = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/universities`);
    dispatch({ type: SET_LIBRARY_UNIVERSITIES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Номера парт (xp_desk_number)
export const getLibraryDeskNumbers = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/desk_numbers`);
    dispatch({ type: SET_LIBRARY_DESK_NUMBERS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список стран (xp_countries)
export const getLibraryCountries = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/countries`);
    dispatch({ type: SET_LIBRARY_COUNTRIES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список субъектов РФ (xp_subjects)
export const getLibraryRfSubjects = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/subjects`);
    dispatch({ type: SET_LIBRARY_RF_SUBJECTS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список школ (schools)
export const getLibrarySchools = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/schools`);
    dispatch({ type: SET_LIBRARY_SCHOOLS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Комнаты для проживания (rooms + roomtypes, без расписания)
export const getLibraryRooms = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/location/rooms`);
    dispatch({ type: SET_LIBRARY_ROOMS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Список социальных групп
export const getLibrarySocialGroups = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/groups/social_groups`);
    dispatch({ type: SET_LIBRARY_SOCIAL_GROUPS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Показатели физической подготовки (Physical_training_indicators)
export const getLibraryPhysicalTrainingIndicators = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/physical_training_indicators`);
    dispatch({ type: SET_LIBRARY_PHYSICAL_TRAINING_INDICATORS, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Справочник типов достижений (xp_personal_file_achievs_types)
export const getLibraryAchievementTypes = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/achievement_types`);
    dispatch({ type: SET_LIBRARY_ACHIEVEMENT_TYPES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уникальные значения «Результат зачисления» (xp_personal_file.resultincluding)
export const getLibraryResultIncluding = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/resultincluding`);
    dispatch({ type: SET_LIBRARY_RESULT_INCLUDING, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уровни выраженности УУД (xp_severity_level)
export const getLibrarySeverityLevels = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/severity_levels`);
    dispatch({ type: SET_LIBRARY_SEVERITY_LEVELS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уникальные иностранные языки (xp_personal_file_lang)
export const getLibraryLanguages = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/languages`);
    dispatch({ type: SET_LIBRARY_LANGUAGES, payload: data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уникальные значения «Наличие специального звания» (xp_personal_file.mil_rank)
export const getLibraryMilRanks = () => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/mil_ranks`);
    dispatch({ type: SET_LIBRARY_MIL_RANKS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные учебные годы для dropdown портфолио
export const getLibraryPortfolioYears = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/years/portfolio/${mid}/available-years`);
    dispatch({ type: SET_LIBRARY_PORTFOLIO_YEARS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные курсы внеурочной деятельности
export const getLibraryAvailableOutCourses = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/courses/${mid}/available-out-courses`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_OUT_COURSES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные курсы доп. образования
export const getLibraryAvailableXpCourses = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/courses/${mid}/available-xp-courses`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_XP_COURSES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные предметы для подгрупп учащегося
export const getLibraryAvailableCourses = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/courses/${mid}/available-courses`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_COURSES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные группы внеурочной деятельности по курсу
export const getLibraryAvailableOutGroups = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/groups/${mid}/available-out-groups`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_OUT_GROUPS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные подгруппы для перевода по предмету
export const getLibraryAvailableSubgroups = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/groups/${mid}/available-subgroups`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_SUBGROUPS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные группы доп. образования по курсу
export const getLibraryAvailableXpGroups = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/groups/${mid}/available-xp-groups`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_XP_GROUPS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Доступные классы для перевода учащегося
export const getLibraryAvailableClasses = (mid) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/groups/${mid}/available-classes`);
    dispatch({ type: SET_LIBRARY_AVAILABLE_CLASSES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

// Уникальные названия вступительного экзамена (xp_personal_file.enterexamNname)
export const getLibraryExamNames = (index) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  try {
    const { data } = await api.get(`/library/users/exam_names/${index}`);
    dispatch({ type: SET_LIBRARY_EXAM_NAMES, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};

//Недели 
export const getLibraryWeeks = (params) => async (dispatch) => {
  dispatch({ type: SET_LIBRARY_LOADING, payload: true });
  const urlParams = new URLSearchParams(params).toString();
  try {
    const { data } = await api.get(`/library/weeks?${urlParams}`);
    dispatch({ type: SET_LIBRARY_WEEKS, payload: data.data });
  } catch (error) {
  } finally {
    dispatch({ type: SET_LIBRARY_LOADING, payload: false });
  }
};
